import newAccount from './newAccount.js';
import BuyerShippingInfo from './buyerShippingInfo.js';
import BuyerUserInfo from './buyerUserInfo.js';

/**
 *
 * Buyer
 *
 * @namespace Buyer
 */
newAccount.Buyer = {
    instance: 'newAccount.Buyer',

    // ---------------------------------------------
    //
    //        Constructor
    //
    // ---------------------------------------------
    init: function(buyer) {
        if (buyer) {
            // Check to see if it is a Buyer object
            if (typeof(buyer.instance) !== 'undefined' && buyer.instance === newAccount.Buyer.instance) {
                this.id = buyer.id;
                this.executiveId = buyer.executiveId;
                this.firstName = buyer.firstName;
                this.lastName = buyer.lastName;
                this.sponsorId = buyer.sponsorId;
                this.accountType = !buyer.accountType ? "20" : buyer.accountType;
                this.isGuest = buyer.isGuest;
                this.priceType = buyer.priceType;
                this.eid = buyer.eid;
                this.authenticationType = buyer.authenticationType;
                this.email = buyer.email;
                this.mobile = buyer.mobile;
                this.mobilePhone = buyer.mobilePhone;
                this.simple = buyer.simple;
                this.isCircleGroupLeader = buyer.isCircleGroupLeader;
                this.qualifyingCode = buyer.qualifyingCode;
                this.shipTo = buyer.shipTo;
                this.userInfo = buyer.userInfo;
                this.myself = buyer.myself;
            }

            // Check to see if is a user object
            else if (typeof(buyer.instance) !== 'undefined' && buyer.instance === newAccount.User.instance) {
                this.id = buyer.id;
                this.executiveId = buyer.executiveId;
                this.firstName = buyer.firstName;
                this.lastName = buyer.lastName;
                this.sponsorId = buyer.sponsorId;
                this.accountType = !buyer.accountType ? "20": buyer.accountType;
                this.isGuest = buyer.isGuest;
                this.priceType = buyer.priceType;
                this.eid = buyer.eid;
                this.authenticationType = buyer.authenticationType;
                this.email = buyer.email;
                this.mobile = "";
                this.mobilePhone = "";
                this.simple = buyer.simple;
                this.isCircleGroupLeader = buyer.isCircleGroupLeader;
                this.qualifyingCode = buyer.qualifyingCode;
                this.shipTo = buyer.shipTo = "";
                this.userInfo = "";
            }

            // Read the values from the stored cookie or local storage.
            else {
                this.id = buyer.id;
                this.executiveId = buyer.executiveId;
                this.firstName = buyer.firstName;
                this.lastName = buyer.lastName;
                this.sponsorId = buyer.sponsorId;
                this.accountType = !buyer.accountType ? "20" : buyer.accountType;
                this.isGuest = buyer.isGuest;
                this.priceType = buyer.priceType;
                this.eid = buyer.eid;
                this.authenticationType = buyer.authenticationType;
                this.email = buyer.email;
                this.mobile = buyer.mobile;
                this.mobilePhone = buyer.mobilePhone;
                this.simple = buyer.simple;
                this.isCircleGroupLeader = buyer.isCircleGroupLeader;
                this.qualifyingCode = buyer.qualifyingCode;
                this.myself = buyer.myself;

                this.shipTo = BuyerShippingInfo;
                this.shipTo.init(buyer.shipTo);

                this.userInfo = BuyerUserInfo;
                this.userInfo.init(buyer.userInfo);
            }
        }
    },

    // ---------------------------------------------
    //
    //        Public Methods
    //
    // ---------------------------------------------

    /**
     * @memberof Buyer
     * @example
     * var buyerJsonObject = Buyer.toJSON()
     * @returns {object}
     */
    toJSON: function(){
        let buyer = {};

        buyer.id = this.id;
        buyer.executiveId = this.executiveId;
        buyer.firstName = this.firstName;
        buyer.lastName = this.lastName;
        buyer.sponsorId = this.sponsorId;
        buyer.accountType = this.accountType;
        buyer.isGuest = this.isGuest;
        buyer.priceType = this.priceType;
        buyer.eid = this.eid;
        buyer.authenticationType = this.authenticationType;
        buyer.email = this.email;
        buyer.mobile = this.mobile;
        buyer.mobilePhone = this.mobilePhone;
        buyer.simple = this.simple;
        buyer.isCircleGroupLeader = this.isCircleGroupLeader;
        buyer.qualifyingCode = this.qualifyingCode;
        buyer.shipTo = this.shipTo !== undefined ? this.shipTo.toString() : "";
        buyer.userInfo = this.userInfo !== undefined ? this.userInfo.toString() : "";
        buyer.myself = this.myself;

        return buyer;
    },

    /**
     * @memberof Buyer
     * @example
     * Buyer.isEmpty()
     * @returns {boolean}
     */
    isEmpty: function(){
        return this.isFieldEmpty(this.id) &&
            this.isFieldEmpty(this.executiveId) &&
            this.isFieldEmpty(this.firstName) &&
            this.isFieldEmpty(this.lastName) &&
            this.isFieldEmpty(this.sponsorId) &&
            this.isFieldEmpty(this.accountType) &&
            this.isFieldEmpty(this.isGuest) &&
            this.isFieldEmpty(this.priceType) &&
            this.isFieldEmpty(this.eid) &&
            this.isFieldEmpty(this.authenticationType) &&
            this.isFieldEmpty(this.email) &&
            this.isFieldEmpty(this.mobile) &&
            this.isFieldEmpty(this.mobilePhone) &&
            this.isFieldEmpty(this.simple) &&
            this.isFieldEmpty(this.isCircleGroupLeader) &&
            this.isFieldEmpty(this.qualifyingCode) &&
            (this.isFieldEmpty(this.shipTo) || this.shipTo.isEmpty()) &&
            (this.isFieldEmpty(this.userInfo) || this.userInfo.isEmpty()) &&
            this.isFieldEmpty(this.myself);
    },

    /**
     * @memberof Buyer
     * @example
     * Buyer.isDistributor()
     * @returns {boolean}
     */
    isDistributor: function() {
        return this.accountType === "10";
    },

    /**
     * @memberof Buyer
     * @example
     * Buyer.isCustomer()
     * @returns {boolean}
     */
    isCustomer: function() {
        return this.accountType === "20";
    },

    /**
     * @memberof Buyer
     * @example
     * Buyer.isPreferredCustomer()
     * @returns {boolean}
     */
    isPreferredCustomer: function() {
        return this.accountType === "30";
    },

    /**
     * @memberof Buyer
     * @example
     * Buyer.isFieldEmpty()
     * @returns {boolean}
     */
    isFieldEmpty: function(fieldValue){
        return fieldValue === null || fieldValue === undefined || fieldValue.length === 0;
    }
};

export default newAccount.Buyer;
